module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/slideshow_desktop1-40df25ce63b2f7da008106637e6b0918.jpg";